import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type SkeletonVariant = 'line' | 'card' | 'table-row' | 'board';

@Component({
  selector: 'app-skeleton',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="tt-skeleton-wrap" [attr.data-variant]="variant()" role="status" aria-label="Loading">
      @switch (variant()) {
        @case ('card') {
          <div class="tt-skeleton-cards">
            @for (row of countArray(); track $index) {
              <div class="tt-skeleton tt-skeleton-card"></div>
            }
          </div>
        }
        @case ('board') {
          <div class="tt-skeleton-board">
            @for (row of countArray(); track $index) {
              <div class="tt-skeleton tt-skeleton-column">
                <div class="tt-skeleton tt-skeleton-line tt-skeleton-line--sm"></div>
                <div class="tt-skeleton tt-skeleton-line"></div>
                <div class="tt-skeleton tt-skeleton-line"></div>
              </div>
            }
          </div>
        }
        @case ('table-row') {
          <div class="tt-skeleton-list">
            @for (row of countArray(); track $index) {
              <div class="tt-skeleton-table-row">
                <div class="tt-skeleton tt-skeleton-line tt-skeleton-line--sm"></div>
                <div class="tt-skeleton tt-skeleton-line"></div>
                <div class="tt-skeleton tt-skeleton-line tt-skeleton-line--sm"></div>
                <div class="tt-skeleton tt-skeleton-line tt-skeleton-line--sm"></div>
              </div>
            }
          </div>
        }
        @default {
          <div class="tt-skeleton-list">
            @for (row of countArray(); track $index) {
              <div class="tt-skeleton tt-skeleton-row">
                <div class="tt-skeleton tt-skeleton-line tt-skeleton-line--sm"></div>
                <div class="tt-skeleton tt-skeleton-line"></div>
              </div>
            }
          </div>
        }
      }
      <span class="sr-only">Loading…</span>
    </div>
  `
})
export class SkeletonComponent {
  readonly count = input(5);
  readonly variant = input<SkeletonVariant>('line');

  readonly countArray = computed(() =>
    Array.from({ length: Math.max(1, this.count()) }, (_, i) => i)
  );
}
